import React, { useEffect, useState } from "react";
import moment from "moment";
import * as functions from "../../utils/functions"

// assets Images
import bgImage from "../../assets/bg/4.png";
import xureIcon from "../../assets/logo.png"
import googlePlay from "../../assets/xure-icon/googlePlay.png";
import appStore from "../../assets/xure-icon/appStore.png";

// icons
import { IoMdCalendar } from "react-icons/io";
import { RiEditBoxLine } from "react-icons/ri";
import { app_universal_link } from "../../utils/varConstant";

const Loader = () => (
  <div className="flex justify-center items-center w-full h-full bg-[#2f2f2f] animate-pulse text-white text-sm">
    Loading...
  </div>
);

const ShareLinkLanding = () => {

  const [boxBreakDetails, setBoxBreakDetails] = useState(null);
  const [coverLoaded, setCoverLoaded] = useState(false);
  const [profileLoaded, setProfileLoaded] = useState(false);


  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const cipher = params.get('data');
    const iv = params.get('iv');

    if (cipher && iv) {
      getBoxBreakDetails();
    } else {
      // Wait and retry in case the params arrive shortly after navigation
      const interval = setInterval(() => {
        const retryParams = new URLSearchParams(window.location.search);
        const retryCipher = retryParams.get('data');
        const retryIv = retryParams.get('iv');

        if (retryCipher && retryIv) {
          clearInterval(interval);
          getBoxBreakDetails();
        }
      }, 200); // Retry every 200ms

      setTimeout(() => clearInterval(interval), 3000); // Stop retrying after 3s
    }
  }, []);

  // open xure app for box break details
  const openXureApp = async () => {

    const url = `${app_universal_link}/box-break/${boxBreakDetails?.status}/${boxBreakDetails?.box_break_id}`;
    try {
      window.location.href = url;
    } catch (error) {
      console.log("Error", error)
    }
  }

  const getBoxBreakDetails = async () => {
    try {
      const getBoxBreak = await functions.GetShareBoxBreakDetails();
      setBoxBreakDetails(getBoxBreak.data[0])
    } catch (error) {
      console.log("Error", error)
    }
  }

  const formatDate = (date) => {
    // Parse date as UTC and convert to local time then format
    return moment.utc(date).local().format('MMMM D, YYYY');
  }

  const formatTime = (time) => {
    // Parse time as UTC, convert to local time, then format with AM/PM
    return moment.utc(time).local().format('h:mm A');
  }

  return (
    <div
      className="h-auto min-h-[100vh] flex flex-col gap-4 justify-center items-center sm:p-2 p-4"
      style={{
        backgroundImage: `url(${bgImage})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
      }}
    >
      <img src={xureIcon} className="w-32" />
      <div className="w-full md:w-[600px] h-auto rounded-xl overflow-hidden bg-[#373737] pb-7">
        {/* Cover Image */}
        <div className="relative h-32 md:h-[200px]">
          {!coverLoaded && <Loader />}
          <img
            src={boxBreakDetails?.image_link}
            alt="Cover"
            onLoad={() => setCoverLoaded(true)}
            className={`absolute top-0 left-0 w-full h-full object-cover transition-opacity duration-300 ${coverLoaded ? "opacity-100" : "opacity-0"}`}
          />

          {/* Profile Picture */}
          <div className="absolute -bottom-[50px] md:-bottom-[60px] left-4 md:left-8 w-fit rounded-full border-[4px] border-[#373737] bg-[#2f2f2f]">
            {!profileLoaded && (
              <div className="absolute inset-0 flex justify-center items-center bg-[#2f2f2f] animate-pulse z-10 rounded-full">
                <span className="text-white text-xs">Loading...</span>
              </div>
            )}
            <img
              src={boxBreakDetails?.box_breaker_picture}
              alt="Profile"
              onLoad={() => setProfileLoaded(true)}
              className={`w-[100px] h-[100px] md:w-[120px] md:h-[120px] rounded-full border-[2px] border-[#F7D091] transition-opacity duration-300 ${profileLoaded ? "opacity-100" : "opacity-0"}`}
            />
          </div>
        </div>

        {/* Content */}
        <div className="mt-16 mx-4 md:mx-8 mb-3">
          <h1 className="text-xl text-white font-medium">{boxBreakDetails?.title ? boxBreakDetails?.title : "-"}</h1>
          <small className="font-semibold text-white">
            Hosted by <span className="text-[#F7D091]">{boxBreakDetails?.box_breaker_name ? boxBreakDetails?.box_breaker_name : "-"}</span>{" "}
            {boxBreakDetails?.username && <span className="font-light text-white">@{boxBreakDetails?.username}</span>}
          </small>
        </div>

        <div className="rounded-lg bg-[#2F2F2F] text-white p-4 mx-4 md:mx-8 mt-0 mb-4">
          <h3 className="text-sm text-start mb-1 font-medium">Event Details</h3>

          <div className="flex items-start bg-[#3D3D3D] px-3 py-1 rounded-xl mb-2">
            <RiEditBoxLine size={32} className="text-[#F7D091]" />
            <div>
              <label className="font-medium">Registration Period:</label>
              <p className="text-white font-light p-0">
                {boxBreakDetails?.registration_start_date ? <>
                  {formatDate(boxBreakDetails?.registration_start_date)} ({formatTime(boxBreakDetails?.registration_start_date)}) - {formatDate(boxBreakDetails?.registration_end_date)} ({formatTime(boxBreakDetails?.registration_end_date)})
                </>
                  : "-"}

              </p>
            </div>
          </div>

          <div className="flex items-start bg-[#3D3D3D] px-3 py-1 rounded-xl">
            <IoMdCalendar size={32} className="text-[#F7D091]" />
            <div>
              <label className="font-medium">Stream Date:</label>
              <p className="text-white font-light p-0">
                {boxBreakDetails?.box_break_start_date ? <>
                  {formatDate(boxBreakDetails?.box_break_start_date)} ({formatTime(boxBreakDetails?.box_break_start_date)})
                </>
                  :
                  "-"}

              </p>
            </div>
          </div>
        </div>

        <div className="mx-4 md:mx-16 text-center">
          <button className="w-full bg-[#F7D091] rounded-[30px] py-2 font-bold" onClick={openXureApp}>Join Now!</button>
          <small className="text-white mt-3">DOWNLOAD NOW!</small>
          <div className="flex gap-2 justify-center my-1">
            <a href="https://play.google.com/store/apps/details?id=com.xdeal&pli=1" target='_blank' className='btn-animation'>
              <img src={googlePlay} className="h-[34px]" />
            </a>
            <a href="https://apps.apple.com/ph/app/xure/id6463198157" target='_blank' >
              <img src={appStore} className="h-[34px]" />
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ShareLinkLanding;
